import type {AutonomyLevelDto, AutonomyLevelValue} from '@devmil/contracts';
import {useId} from 'react';

import {autonomyEligibilityLabel} from '../../lib/format.js';

/**
 * Níveis de autonomia. Subir de nível é decisão manual do Thiago; a tela só
 * mostra qual está em uso e o que falta para os outros.
 */
export const AutonomyLevels = ({
  levels,
  effectiveLevel,
}: {
  levels: readonly AutonomyLevelDto[];
  effectiveLevel: AutonomyLevelValue;
}) => {
  const headingId = useId();

  return (
    <section className="dm-panel" aria-labelledby={headingId}>
      <div className="dm-panel-head">
        <h2 id={headingId}>Níveis de autonomia</h2>
        <span className="dm-connection">
          {`MODO EFETIVO: NÍVEL ${effectiveLevel}`}
        </span>
      </div>
      <div className="dm-autonomy">
        {levels.map((level) => (
          <div
            className={
              level.level === effectiveLevel
                ? 'dm-level is-current'
                : 'dm-level'
            }
            key={level.level}
            data-testid="autonomy-level"
          >
            <strong>{level.level}</strong>
            <span>{level.description}</span>
            <em>{autonomyEligibilityLabel(level.eligibility)}</em>
          </div>
        ))}
      </div>
    </section>
  );
};
